import { createSlice } from "@reduxjs/toolkit";
import { FormStepData, formStepReducerInit } from "./formStep.type";
import { uploadCompetitorFile } from "../useCases/uploadCompetitorFile/upload-competitor-file.use-case";
import { triggerUnzip } from "../useCases/trigger-unzip/triggerUnzip.use-case";
import { triggerUploadS3Bucket } from "../useCases/trigger-upload-s3-bucket/triggerUploadS3bucket.use-case";
import { triggerAwInsert } from "../useCases/trigger-aw-insert/triggerAwInsert.use-case";
import { submitManualCorrection } from "../useCases/submit-manual-correction/submitManualCorrection.use-case";
import { reuploadCsv } from "../useCases/reupload-csv/reuploadCsv.use-case";

export const FORM_STEP_FEATURE_KEY = 'formStep';

export const initialFormStepState: FormStepData = formStepReducerInit();

const formStepSlice = createSlice({
	name: FORM_STEP_FEATURE_KEY,
	initialState: initialFormStepState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			// schedule type
			// user
			.addCase(uploadCompetitorFile.pending, (state, action) => {
				state.uploadingFile.push({
					labId: Number(action.meta.arg.laboratoryId),
					fileName: action.meta.arg.fileName
				});
			})
			.addCase(uploadCompetitorFile.fulfilled, (state, action) => {
				state.uploadingFile = state.uploadingFile.filter(
					(file) => file.labId !== Number(action.meta.arg.laboratoryId)
						&& file.fileName !== action.meta.arg.fileName
				);
			})
			.addCase(uploadCompetitorFile.rejected, (state, action) => {
				state.uploadingFile = state.uploadingFile.filter(
					(file) => file.labId !== Number(action.meta.arg.laboratoryId)
						&& file.fileName !== action.meta.arg.fileName
				);
			})
			// preprocessing
			.addCase(triggerUnzip.fulfilled, (state) => {
				state.unzipRunning = false;
			})
			.addCase(triggerUnzip.pending, (state) => {
				state.unzipRunning = true;
			})
			.addCase(triggerUnzip.rejected, (state) => {
				state.unzipRunning = false;
			})
			.addCase(triggerUploadS3Bucket.pending, (state, action) => {
				state.uploadingS3Bucket = action.meta.arg.step;
			})
			.addCase(triggerUploadS3Bucket.fulfilled, (state) => {
				state.uploadingS3Bucket = null;
			})
			.addCase(triggerUploadS3Bucket.rejected, (state) => {
				state.uploadingS3Bucket = null;
			})
			// Insert in Audiowizard
			.addCase(triggerAwInsert.pending, (state) => {
				state.awInsertRunning = true;
			})
			.addCase(triggerAwInsert.fulfilled, (state) => {
				state.awInsertRunning = false;
			})
			.addCase(triggerAwInsert.rejected, (state) => {
				state.awInsertRunning = false;
			})
			.addCase(submitManualCorrection.pending, (state) => {
				state.correctingCSvLineManually = true;
			})
			.addCase(submitManualCorrection.fulfilled, (state) => {
				state.correctingCSvLineManually = false;
			})
			.addCase(submitManualCorrection.rejected, (state) => {
				state.correctingCSvLineManually = false;
			})
			// reupload CSV
			.addCase(reuploadCsv.pending, (state) => {
				state.reuploadingCsv = true;
			})
			.addCase(reuploadCsv.fulfilled, (state) => {
				state.reuploadingCsv = false;
			})
			.addCase(reuploadCsv.rejected, (state) => {
				state.reuploadingCsv = false;
			})
	},
});

export const formStep = formStepSlice.reducer;

export const formStepActions = formStepSlice.actions;
